<template>
  <v-navigation-drawer
    :model-value="drawer"
    color="primary"
    temporary
    location="right"
    width="600"
    @update:model-value="change"
  >
    <div class="pa-8">
      <div class="d-flex justify-space-between align-center">
        <h1 class="text-white mt-6">Structures</h1>
        <v-btn @click="$store.commit('toggleStructuresShow')" icon color="white"
          ><v-icon>mdi-close</v-icon></v-btn
        >
      </div>

      <p class="mb-4 text-white" style="font-size: 12px">
        You can browse through post structures that you have created.
      </p>

      <v-card flat class="pt-4" color="white" v-if="userProfile">
        <v-data-table
          :headers="headers"
          :items="structures"
          :items-per-page="5"
          hide-default-header
          @click:row="select"
          style="cursor: pointer"
          :search="search"
          :loading="structures_loading"
        >
          <template v-slot:[`item.actions`]="{ item }">
            <v-menu transition="slide-y-transition" bottom>
              <template v-slot:activator="{ props }">
                <v-btn v-bind="props" icon>
                  <v-icon size="small">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item link class="px-4" @click="select(item)">
                  <v-icon size="small" class="mr-3">mdi-send</v-icon>
                  <v-list-item-title>Use</v-list-item-title>
                </v-list-item>
                <v-list-item link class="px-4">
                  <v-icon size="small" class="mr-3">mdi-pencil</v-icon>
                  <v-list-item-title>Edit</v-list-item-title>
                </v-list-item>
                <v-list-item
                  link
                  class="px-4"
                  @click="$store.dispatch('deleteMedia', item.uid)"
                >
                  <v-icon size="small" class="mr-3">mdi-delete</v-icon>
                  <v-list-item-title>Delete</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
        </v-data-table>
      </v-card>
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

export default {
  computed: {
    ...mapState({
      userProfile: (state) => state.users.userProfile,
      structures: (state) => state.structures.structures,
      structures_loading: (state) => state.loading.structures,
      drawer: (state) => state.structures.show,
    }),
  },
  data() {
    return {
      headers: [
        {
          text: "Title",
          align: "start",
          sortable: false,
          value: "title",
        },

        // { text: "Actions", value: "actions", align: "end" },
      ],
      items: [],
      loading: false,
      next_page: "",
      search: "",
      search_media: "",
      tab: 0,
    };
  },
  methods: {
    change(v) {
      if (!v) {
        this.$store.commit("toggleStructuresShow");
      }
    },
    formatDate(d) {
      return moment(d.toDate()).format("DD-MM-YYYY");
    },
    select(click, row) {
      console.log(row.item);
      this.$store.commit("setPostStructure", row.item);
      this.$store.commit("toggleStructuresShow");
    },
  },
};
</script>

<style lang="scss" scoped></style>
